<template>
    <BzDialog
        visible
        width="960px"
        :custom-class="`pz-save-to-workspace-dialog pz-save-to-workspace-dialog__${service.type}`"
        :before-close="() => service.onClose()"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="$t(`BaseSaveToWorkspace.Main.title`)"
        v-bind="$attrs"
    >
        <RangeSelector />
        <FolderSelector />
        <DrugAutoUpdateSelector v-if="service.enableAutoUpdate" />

        <template
            slot="footer"
            class="dialog-footer"
        >
            <button
                class="pt-ui-btn"
                size="small"
                @click="service.onClose()"
            >
                {{ $t('BaseSaveToWorkspace.Main.cancel') }}
            </button>
            <button
                class="pt-ui-btn"
                size="small"
                type="primary"
                :data-dialog-type="service.type"
                :disabled="service.isSubmitButtonDisabled()"
                @click="service.onSubmit()"
            >
                <PtIcon
                    v-if="service.isSubmitting"
                    icon="SolidLoadingBars"
                    class="s2w-submit-loading-icon"
                />
                <template v-else>
                    {{ $t('BaseSaveToWorkspace.Main.submit') }}
                </template>
            </button>
        </template>
    </BzDialog>
</template>

<script>
import BzDialog from '@patsnap-biz/dialog';
import PtIcon from '@patsnap-biz/icon';
import FolderSelector from '../Basic/components/FolderSelector/FolderSelector.vue';
import RangeSelector from '../Basic/components/RangeSelector/RangeSelector.vue';
import DrugAutoUpdateSelector from '../Basic/components/DrugAutoUpdateSelector/DrugAutoUpdateSelector.vue';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';

export default {
    name: 'SaveDrugToWorkspaceDialog',
    components: {
        BzDialog,
        FolderSelector,
        RangeSelector,
        PtIcon,
        DrugAutoUpdateSelector,
    },
    provide() {
        return {
            service: this.service,
        };
    },
    props: {
        service: {
            type: Object,
            required: true,
        },
    },
};
</script>
